export default __webpack_public_path__ + "static/media/plain-sticker-l.956a23ca.png";